import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageSEO from '../components/PageSEO';
import { Briefcase, Scale, GraduationCap, Heart, Settings, TrendingUp, Users, Mic } from 'lucide-react';
import './CapabilitiesPage.css';

const CapabilitiesPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const capabilities = [
    {
      icon: <Briefcase size={32} />,
      title: 'Executive Leadership & Governance',
      description: 'Board advisory, executive team facilitation and coaching, and governance structures that enable strategic decision-making.'
    },
    {
      icon: <Scale size={32} />,
      title: 'Legal & Compliance',
      description: 'Employment law, policy development, and compliance frameworks that mitigate risk and ensure regulatory adherence.'
    },
    {
      icon: <GraduationCap size={32} />,
      title: 'Strategic Learning & Development',
      description: 'Comprehensive L&D programs, leadership assessment and development initiatives, leadership coaching and advisory, and organizational capability building.'
    },
    {
      icon: <Heart size={32} />,
      title: 'Organizational Wellness',
      description: 'Strategic Wellness Intensives · Workforce Mental Fitness Programs · Executive Advisory Partnership · Crisis & Critical Incident Support · Custom Wellness Strategy & Design.'
    },
    {
      icon: <Settings size={32} />,
      title: 'Operations & Technology',
      description: 'Talent technology implementation, HRIS optimization, process automation, and operational efficiency analysis.'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'Marketing & Business Strategy',
      description: 'Business growth planning, strategic execution support, brand development and positioning, product innovation planning, customer experience strategy, marketing communications, and Revenue as a Service (RAAS).'
    },
    {
      icon: <Users size={32} />,
      title: 'Workforce Development',
      description: 'Strategic workforce planning, skills gap analysis, career pathway design, and comprehensive talent development initiatives.'
    },
    {
      icon: <Mic size={32} />,
      title: 'Keynote Speaking',
      description: 'Thought leadership presentations on Leadership, Strategy to Execution, Future-Proofing Talent, organizational design, and the future of work for conferences and corporate events.'
    }
  ];

  return (
    <div className="capabilities-page">
      <PageSEO
        title="Right 6+ Capabilities"
        path="/capabilities"
        description="Extended talent management services including executive development, compliance training, organizational transformation, DEI programs, change management, and HR technology implementation."
      />
      <Header />
      
      {/* Hero Section */}
      <section className="cap-hero">
        <div className="cap-hero-container">
          <div className="cap-hero-badge">Extended Capabilities</div>
          <h1 className="cap-hero-title">
            Right 6™+<br/>
            Capabilities
          </h1>
          <p className="cap-hero-subtitle">
            Extended capabilities for comprehensive organizational transformation beyond the core Right 6™ Framework.
          </p>
        </div>
      </section>

      {/* Intro Section */}
      <section className="cap-intro">
        <div className="cap-intro-container">
          <h2 className="cap-section-title">Beyond the Foundation</h2>
          <p className="cap-intro-text">
            While The Right 6™ Framework addresses the core dimensions of organizational talent architecture, many organizations require additional specialized capabilities. Our Right 6™+ services extend beyond foundational talent management to provide comprehensive support across leadership, compliance, technology, business strategy, and more.
          </p>
        </div>
      </section>

      {/* Capabilities Grid */}
      <section className="cap-grid-section">
        <div className="cap-grid-container">
          <div className="cap-grid">
            {capabilities.map((capability, index) => (
              <div key={index} className="cap-card">
                <div className="cap-icon">{capability.icon}</div>
                <h3 className="cap-card-title">{capability.title}</h3>
                <p className="cap-card-description">{capability.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cap-cta">
        <div className="cap-cta-container">
          <h2 className="cap-cta-title">Ready to Explore Extended Capabilities?</h2>
          <p className="cap-cta-text">
            Connect with our team to discuss how Right 6™+ services can support your organization's unique needs.
          </p>
          <button className="btn btn-cap-primary" onClick={() => window.open('https://form.jotform.com/260186646305054', '_blank')}>
            Schedule a Consultation
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CapabilitiesPage;